import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_CONFIG } from '@core/config/app-config.token';
import { AuthSessionStore } from '@core/auth/auth-session.store';

/**
 * Attaches the bearer token to requests for our own API only (REST + GraphQL,
 * since the GraphQL HttpLink goes through HttpClient). Third-party URLs never
 * receive the token.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(APP_CONFIG);
  const token = inject(AuthSessionStore).token();
  const isOwnApi = req.url.startsWith(config.apiUrl) || req.url.startsWith(config.graphqlUrl);

  if (!token || !isOwnApi || req.headers.has('Authorization')) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
